/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Reportingapikeys_Status_Active2Inputs */

const en_settings_reportingapikeys_status_active2 = /** @type {(inputs: Settings_Reportingapikeys_Status_Active2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Settings_Reportingapikeys_Status_Active2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_status_active2 = /** @type {((inputs?: Settings_Reportingapikeys_Status_Active2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Status_Active2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_status_active2(inputs)
});
export { settings_reportingapikeys_status_active2 as "settings_reportingApiKeys_status_active" }